/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 */
import api from '@/lib/api';

/** Quota AI della clinica corrente (header x-clinic-id inviato automaticamente). */
export const getMyAiUsage = async () => (await api.get('/ai-usage/me')).data;

/** Admin: configurazione del meter (tier, route misurate, stato tokenizer). */
export const getAiUsageConfig = async () => (await api.get('/admin/ai-usage/config')).data;

/** Admin: elenco tenant con piano + statistiche del mese (YYYY-MM, default corrente). */
export const listAiUsageTenants = async (month) => (await api.get('/admin/ai-usage/tenants', { params: month ? { month } : {} })).data;

/** Admin: crea/aggiorna piano di una clinica. body: { plan_tier?, max_monthly_requests?, reset_counter?, notes? } */
export const upsertAiUsageTenant = async (clinicId, body) => (await api.put(`/admin/ai-usage/tenants/${encodeURIComponent(clinicId)}`, body)).data;

/** Admin: ultimi eventi (chiamate AI) di una clinica. */
export const getAiUsageEvents = async (clinicId, { month, limit = 100 } = {}) =>
  (await api.get(`/admin/ai-usage/tenants/${encodeURIComponent(clinicId)}/events`, { params: { ...(month ? { month } : {}), limit } })).data;

/** Admin: storico mensile aggregato di una clinica. */
export const getAiUsageHistory = async (clinicId, months = 12) =>
  (await api.get(`/admin/ai-usage/tenants/${encodeURIComponent(clinicId)}/history`, { params: { months } })).data;

export const PLAN_TIER_LABELS = { Entry: 'Entry', Professional: 'Professional', Enterprise: 'Enterprise' };

export const formatCompact = (n) => new Intl.NumberFormat('it-IT', { notation: 'compact', maximumFractionDigits: 1 }).format(Number(n) || 0);
export const formatBytes = (b) => {
  const n = Number(b) || 0;
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / 1024 / 1024).toFixed(2)} MB`;
};
